module.exports = __webpack_public_path__ + "img/landscape.b9353ebe.svg";